<template>
    <wine-list-item class="chi_wine_list_item--container" :item="item" :pricing-types="pricingTypes"
                  :layout="priceLayout" :is-grouped-by-price="isGroupedByPrice" :show-bin="showBin"></wine-list-item>
</template>

<script lang="ts">
/**
 * Custom component for CHI food items.
 *
 * @author Jasper Howard <jhoward@peppermillcas.com>
 * @version 1.0.1
 * @copyright  Copyright (C) 2023-2025, Peppermill Inc. All rights reserved. Redistribution and use in source and binary forms, with or without modification, are not permitted.
 *
 *    2023-07-24 (1.0.0) (jhoward)
 *      - <chi-default-item> copied to <chi-wine-list-item>.
 *
 *    2025-04-08 (1.0.1) (jhoward)
 *      - Add CSS centering in <chi-wine-list-item>.
 */

import {defineComponent, PropType} from "vue";
import {MENU_ITEM_LAYOUT, MenuItem} from "../defs";
import WineListItem from "./wineListItem.vue";

export default defineComponent({
  name: 'chi-wine-list-item',
  components: {
    WineListItem
  },
  props: {
    item: {
      type: Object as PropType<MenuItem>,
      required: true
    },
    pricingTypes: {
      type: Array as PropType<string[]>,
      default: () => []
    },
    priceLayout: {
      type: String as PropType<MENU_ITEM_LAYOUT>,
      default: ''
    },
    isGroupedByPrice: {
      type: Boolean,
      default: false
    },
    showBin: {
      type: Boolean,
      default: false
    }
  },
})
</script>

<style scoped>

</style>